import { Capacitor } from '@capacitor/core'
import React, { Component, ErrorInfo } from 'react'

interface Props {
	children: React.ReactNode
}

interface State {
	hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false }
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		if (!Capacitor.isNativePlatform()) {
			console.error('ErrorBoundary caught an error: ', error, errorInfo)
		}

		this.setState({ hasError: true })
	}

	render() {
		return this.props.children
	}
}

export default ErrorBoundary
